import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title = "Niks Elite Cleaning | Professional Cleaning Services Melbourne",
  description = "Professional cleaning services in Melbourne's western suburbs. Specializing in end of lease, carpet, domestic and commercial cleaning with same day availability.",
  image = "https://www.nikselitecleaning.com.au/img/home-img.png",
  type = "website"
}) => {
  const location = useLocation();
  const baseUrl = "https://www.nikselitecleaning.com.au";
  const canonical = baseUrl + location.pathname;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Niks Elite Cleaning" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Niks Elite Cleaning" />
    </Helmet>
  );
};

export default SEO;
